import type { Target } from "@/utils/types/flavor";
import type { CurrentSensory } from "./computeCurrent";

// Squared-error sum across taste + smell axes vs the target. Lower = closer.
export function computeLoss(
  current: CurrentSensory | null,
  target: Target | null | undefined
): number | null {
  if (!current || !target) return null;
  let s = 0;
  for (let i = 0; i < target.taste.length; i++) {
    const d = target.taste[i] - current.taste[i];
    s += d * d;
  }
  for (let i = 0; i < target.smell.length; i++) {
    const d = target.smell[i] - current.smell[i];
    s += d * d;
  }
  return s;
}
